const listOfCurrencies = [
    {
        name: 'Nigerian Naira',
        symbol: 'NGN',
    },
    {
        name: 'Kenyan Shilling',
        symbol: 'KES',
    },
    {
        name: 'Ugandan Shilling',
        symbol: 'UGX',
    },
    {
        name: 'Tanzanian Shilling',
        symbol: 'TZS',
    },
    {
        name: 'Malawian Kwacha',
        symbol: 'MWK',
    },
    {
        name: 'South African Rand',
        symbol: 'ZAR',
    },
    {
        name: 'Zambian Kwacha',
        symbol: 'ZMW',
    },
    {
        name: 'Rwandan Franc',
        symbol: 'RWF',
    },
    {
        name: 'Botswana Pula',
        symbol: 'BWP',
    },
    {
        name: 'Congolese Franc',
        symbol: 'CDF',
    },
    {
        name: 'Benin FCFA',
        symbol: 'XOF_BJ',
    },
    {
        name: 'Togo FCFA',
        symbol: 'XOF_TG',
    },
    {
        name: 'Senegal FCFA',
        symbol: 'XOF_SN',
    },
    {
        name: 'Mali FCFA',
        symbol: 'XOF_ML',
    },
    {
        name: 'Burkina Faso FCFA',
        symbol: 'XOF_BF',
    },
    {
        name: 'Cameroon FCFA',
        symbol: 'XAF_CM',
    },
    {
        name: "Côte d'Ivoire FCFA",
        symbol: 'XOF_CI',
    },
    {
        name: 'Gabon FCFA',
        symbol: 'XAF_GA',
    },
    {
        name: 'Congo FCFA',
        symbol: 'XAF_CG',
    },
];
export default listOfCurrencies;
